import email from "../../Apicall/controlCenter";
export default {
  create({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await email.create(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  createSms({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await email.createSms(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAll({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await email.getAll(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAllSms({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await email.getAllSms(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
